// dispatch-trip targets the external (business) Supabase project.
// Lovable exposes EXTERNAL_SUPABASE_URL as a build secret; local dev uses VITE_DISPATCH_OVERRIDE_URL.
export const EXTERNAL_URL =
  import.meta.env.VITE_DISPATCH_OVERRIDE_URL ||
  import.meta.env.VITE_EXTERNAL_SUPABASE_URL ||
  import.meta.env.EXTERNAL_SUPABASE_URL;
const EXTERNAL_KEY =
  import.meta.env.VITE_DISPATCH_OVERRIDE_KEY ||
  import.meta.env.VITE_EXTERNAL_SUPABASE_ANON_KEY ||
  import.meta.env.EXTERNAL_SUPABASE_ANON_KEY;

// All other edge functions (customer-login, calculate-fare, etc.) live on the Lovable project.
const LOVABLE_URL = `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co`;
const LOVABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Functions that run on the external (business) DB, not the Lovable project.
const EXTERNAL_FUNCTIONS = new Set(['dispatch-trip', 'calculate-fare', 'customer-nearby-drivers']);

export async function invokeEdgeFunction(
  functionName: string,
  body: Record<string, unknown>,
  authToken?: string,
  options?: { signal?: AbortSignal },
): Promise<{ data: any; error: any; aborted?: boolean }> {
  try {
    const useExternal = EXTERNAL_FUNCTIONS.has(functionName);
    const baseUrl = useExternal ? EXTERNAL_URL : LOVABLE_URL;
    const apiKey = useExternal ? EXTERNAL_KEY : LOVABLE_KEY;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'apikey': apiKey,
      'Authorization': authToken ? `Bearer ${authToken}` : `Bearer ${apiKey}`,
    };

    const res = await fetch(`${baseUrl}/functions/v1/${functionName}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
      signal: options?.signal,
    });

    const data = await res.json();
    if (!res.ok) {
      return { data, error: data?.error || `HTTP ${res.status}` };
    }
    return { data, error: null };
  } catch (err: any) {
    if (err?.name === 'AbortError') {
      return { data: null, error: 'aborted', aborted: true };
    }
    return { data: null, error: err.message || 'Network error' };
  }
}
